
import Api from '@/Scripts/api/api';
import { TrackerProductObject, TrackerProductClicked } from '@/Scripts/lib/helper/trackingHelper.js';

export default {
  methods: {
    async trackClick () {
      TrackerProductClicked(TrackerProductObject({
        index: this.index,
        product: this.model,
        colorVariant: this.currentVariant,
        size: this.selectedSizeObject ? this.selectedSizeObject.Size : '',
        outlet: this.outlet,
        recoVersion: this.recoVersion,
        pageType: this.$root._vnode.tag.replace(/vue-component-\d*-/, '').trim(),
        sourceObject: this.trackSourceObject
      }));
      // epi search tracking for searchpage
      if (
        typeof this.model.searchTrackData !== 'undefined' &&
        Object.keys(this.model.searchTrackData).length > 0
      ) {
        // event.preventDefault();
        // console.log('post:', this.model.searchTrackData);
        try {
          await Api.postContentByFriendlyUrl(
            this.model.trackUrl,
            this.model.searchTrackData
          );
          // console.log(response);
        } catch (e) {
          console.error(e);
        }
      }
    }
  }
};
